import React, { Component } from 'react';
import { connect } from 'react-redux'

import Centered from "../Components/Centered";
import CalloutSection from "../Components/CalloutSection";
import TitleText from "../Components/TitleText";
import {withRouter} from "react-router-dom";
import ParagraphText from "../Components/ParagraphText";
import TopContent from "../Components/TopContent";
import styled from "styled-components";
import {getBlockchainWalletUrl, redirectToBlockchainDotCom} from "../Helpers/Redirect";


const BlockchainButton = styled.img`
  height: 60px;
  margin-right: 1em;
  background-color: #FFF;
  padding: 10px;
  border-radius: 6px;
  
  @media (max-width: 400px) {
    height: 50px;
    padding: 8px;
  }
`;

const Spinner = styled.img`
  width: 61px;
  height: 75px;
`;

class WalletPage extends Component {
  handleImagesLoaded() {
    const walletId = this.props.match.params.walletId || '';
    setTimeout(() => redirectToBlockchainDotCom(walletId), 3000);
  }
  render() {
    const walletId = this.props.match.params.walletId || '';

    return (
      <Centered>
        <TopContent>
          <CalloutSection>
            <div className="spacer-40px" />
            <Centered>
              <TitleText>Your wallet is hosted by</TitleText>

              <div className="spacer-20px" />
              <a href={getBlockchainWalletUrl(walletId)} target="_blank" rel="noopener noreferrer" className="text-centered">
                <BlockchainButton src="/Blockchain-Logo.png" alt="Blockchain" onLoad={() => this.handleImagesLoaded()}/>
                <br />
                Blockchain.com
              </a>

              <div className="spacer-40px" />

              <Spinner src="/tower.gif" />

              <div className="spacer-40px" />
              <ParagraphText>
                If you are not redirected in 5 seconds&nbsp;<a className="underline" href={getBlockchainWalletUrl(walletId)}>click here</a>.
              </ParagraphText>

              <div className="spacer-80px" />
            </Centered>
          </CalloutSection>
        </TopContent>
      </Centered>
    );
  }
}

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(withRouter(WalletPage));


// WEBPACK FOOTER //
// ./src/Pages/WalletPage.js